var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 46.2v-6.9H18.4c-3.8 0-6.9 3.1-6.9 6.9m11.1 7h18.5c2.6 0 3.9 0 4.9-.5.9-.4 1.6-1.2 2-2 .5-1 .5-2.3.5-4.9V14.3c0-2.6 0-3.9-.5-4.9-.4-.9-1.2-1.6-2-2-1-.5-2.3-.5-4.9-.5H22.6c-3.9 0-5.8 0-7.3.8-1.3.7-2.4 1.7-3 3-.8 1.5-.8 3.4-.8 7.3v24.1c0 3.9 0 5.8.8 7.3.7 1.3 1.7 2.4 3 3 1.5.8 3.4.8 7.3.8z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })));
}
export default SvgBookIc;